import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "../../Components/Button/Button";
import { blogData, getAllDraftBlogs } from "../../redux/blogs/blogSlice";
import "../UserBlogs/UserBlogs.css"
import "../AllBlogs/TableStyle.css";
import CustomDropdown from "../../Components/CustomDropdown/CustomDropdown.jsx"
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  deleteBlog,
  getDraftBlogById,
  clearBlogSliceStates,
  clearBlogDraftData,
  clearBlogSliceData,
} from "../../redux/blogs/blogSlice";
import DropActions from "../../Components/DropActions/DropActions.jsx";
import Image from "../../Components/Image/Image";
import Cookies from "js-cookie";
import LogoutPopup from "../../Components/Popups/LogoutPopup/LogoutPopup.jsx";
import BlogDashboardMenu from "../../Layouts/Menu/BlogDashboardManagement/BlogDashboardMenu.js";
import EditBlogPopup from "../../Components/Popups/EditBlogPopup/EditBlogPopup.jsx";
import ComponentLoader from "../../Components/loaders/ComponentLoader/ComponentLoader.jsx";
import BlogPreview from "../../Components/Popups/BlogPreview/BlogPreviewPopup.js";

const Draft = () => {
  const {
    isBlogSliceFetching,
    isBlogSliceFetchingSmall,
    isBlogEditSliceSuccess,
    isBlogDuplicatedSliceSucess,
    isBlogSliceError,
    blogSliceErrorMessage,
    blogSliceSuccessMessage,
    isBlogActiveInactiveSuccess,
    isBlogSliceSuccess,
    isBlogDeleteSliceSuccess,
    allBlogs,
    blogDraft,
    blogCount,
    blogDetail,
    totalDrafts,
  } = useSelector((state) => state.blog);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedBlogId, setSelectedBlogId] = useState([]);
  const [selectedBlog, setSelectedBlog] = useState([]);
  const [isDropAction, setIsDropAction] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [statusPopup, setStatusPopup] = useState(false);
  const [editBlogPopup, setEditBlogPopup] = useState(false);
  const [previewPopup, setPreviewPopup] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isPerPageDrop, setIsPerPageDrop] = useState(false);
  const [perPageDropName, setPerPageDropName] = useState(10);
  const [orgId, setOrgId] = useState(null)
  const [loggedInUser , setLoggedInUser] = useState(null)
  
  const toggleActionDropdown = (rowId, blog) => {
    setIsDropAction(isDropAction === rowId ? false : rowId);
    setSelectedBlogId(rowId);
    setSelectedBlog(blog);
  };

  const dropActionOptions = [
    { label: "Delete Blog", onClick: () => setDeletePopup(true) },
  ];

  const BlogSearchHandler = (searchValue) => {
    const keywords = searchValue.split(",").map((keyword) => keyword.trim());
    setCurrentPage(1);
    setSearchQuery(keywords);
  };
  const handleStatusPopup = (blogId) => {
    setSelectedBlogId(blogId);
    setStatusPopup(true);
  };

  const onChangePerPage = (obj) => {
    setPerPageDropName(obj.id);
    // setIsAllChecked(false);
    // setSelectedApplicants([]);
  };
  const clearSearch = () => {
    setSearchQuery("");
    setCurrentPage(1);
  };

  const handleDelete = (blogId) => {
    console.log("del", blogId);
    let obj = {
      id: selectedBlogId,
      userId : loggedInUser ? loggedInUser : ""
    };
    dispatch(deleteBlog(obj));
  };


    const cookieLoginData = Cookies.get("loginData");
    const parsedLoginData = JSON.parse(cookieLoginData);
  
    useEffect(() => {
      if (cookieLoginData) {
        const parsedLoginData = JSON.parse(cookieLoginData);
        setOrgId(parsedLoginData?.organizationId ?? null);
        setLoggedInUser(parsedLoginData?.id ?? null);
      }
    }, [cookieLoginData]);
    useEffect(() => {
      return () => {
          dispatch(clearBlogDraftData());
          dispatch(clearBlogSliceStates());
      };
  }, []); // Runs only on unmount

  useEffect(() => {
    let obj = {
        perPageCount: perPageDropName,
        searchValue: searchQuery,
        pageNumber: currentPage,
    };
    if(parsedLoginData?.organizationId == "52c3b93c-59ba-44e7-8e99-bd5fc889b68f" && parsedLoginData?.id == "2c4ac9cb-3355-42ab-b57a-4b6db148bf88"){ 
      dispatch(getAllDraftBlogs(obj))
    }else{
      dispatch(getDraftBlogById(obj));
    }
    return () => {
      dispatch(clearBlogDraftData());
      dispatch(clearBlogSliceStates());
    };
  }, [searchQuery,perPageDropName]);

  const loadMore = () => {
    dispatch(
        getDraftBlogById({
        perPageCount: perPageDropName,
        pageNumber: currentPage + 1,
        searchValue: searchQuery,
      })
    );
   
  };
  const BlogsRightMenuoption=[
    () => (
      <CustomDropdown
        className={"current"}
        dropName={perPageDropName}
        options={[
          { name: "10", id: 10 },
          { name: "20", id: 20 },
          { name: "30", id: 30 },
          { name: "40", id: 40 },
          { name: "50", id: 50 },
          { name: "Max", id: totalDrafts },
        ]}
        isActive={isPerPageDrop}
        setIsActive={setIsPerPageDrop}
        onSelect={onChangePerPage}
      />
    )
      ]
  const successToast = () => {
    toast.success(blogSliceSuccessMessage, {
      // position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 3000, // Close the toast after 3 seconds
      hideProgressBar: false, // Display progress bar
      pauseOnHover: true, // Pause the timer when hovering over the toast
    });
  };

  const errorToast = () => {
    toast.error(blogSliceErrorMessage, {
      // position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 3000, // Close the toast after 3 seconds
      hideProgressBar: false, // Display progress bar
      pauseOnHover: true, // Pause the timer when hovering over the toast
    });
  };

  useEffect(() => {
    if (isBlogDeleteSliceSuccess) {
      successToast();
      setDeletePopup(false);
      // setEditBlogPopup(false);
    }
    return () => {
      dispatch(clearBlogSliceStates());
    };
  }, [isBlogDeleteSliceSuccess]);

  useEffect(() => {
    if (isBlogSliceError) {
      errorToast();
    }
  }, [isBlogSliceError]);
  return (
    <>
      <ToastContainer />
      {deletePopup && (
        <LogoutPopup
          showActive={deletePopup}
          userId={selectedBlogId}
          message={"Are you sure you want to delete this Blog?"}
          onCancel={() => setDeletePopup(false)}
          onAllow={handleDelete}
          isPopupFetching={isBlogSliceFetchingSmall}
        />
      )}

      <BlogDashboardMenu
        searchFunction={BlogSearchHandler}
        clearSearch={clearSearch}
        currentCount={blogDraft.length}
        // totalCount={blogDraft.length}
        BlogsRightMenuoption={BlogsRightMenuoption}
        totalCount={totalDrafts && totalDrafts}
        // onClickCreateBlog={() => navigate(`/create-blog`)}
      />
      <div className="wrapperBox singleMenu">
        {isBlogSliceFetching && <ComponentLoader />}
        <div className="tableWrapper wrapWithButton checkboxTable noIconTable actionFix draftTable">
          <table className="darkHeaderTable">
            <thead>
              <tr>
                <th>
                  <div className="tableHeading">
                    <img src="/assets/svg/teacher.svg" alt="" />
                    Draft Title
                  </div>
                </th>
                <th>
                  <div className="tableHeading">
                    <img src="/assets/svg/user.svg" alt="" />
                    Draft Description
                  </div>
                </th>

                <th>
                  <div className="tableHeading">
                    <img src="/assets/svg/user.svg" alt="" />
                    Created On
                  </div>
                </th>
                <th>
                  <div className="tableHeading">
                    <img src="/assets/svg/user.svg" alt="" />
                    Action
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {blogDraft?.map((blog, index) => (
                <tr key={blog?.id}>
                  <td>
                    <div
                      className="tableData pointer"
                      onClick={() => {
                        console.log("dataa",blog)
                        navigate(`/create-blog`,{state:{draftData :blog}});
                      }}
                    >
                      {blog?.blog_Title}
                    </div>
                  </td>
                  <td>
                    {/* <div className="tableData">{blog.blog_description}</div> */}
                    {blog?.blog_description?.split(" ")?.slice(0, 6)?.join(" ")}
                    {blog?.blog_description?.split(" ")?.length > 6
                      ? "..."
                      : ""}
                  </td>

                  <td>
                    <div className="tableData">
                      {moment(blog?.blog_CreatedOn).format("MMM DD YYYY")}
                    </div>
                  </td>

                  <td>
                    <div
                      className="tableData"
                      onClick={() => toggleActionDropdown(blog?.id, blog)}
                    >
                      <button
                        type="button"
                        className="actionTrigger"
                        aria-label="Row actions"
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <circle cx="12" cy="5" r="1.6" fill="currentColor" />
                          <circle cx="12" cy="12" r="1.6" fill="currentColor" />
                          <circle cx="12" cy="19" r="1.6" fill="currentColor" />
                        </svg>
                      </button>
                      <DropActions
                        isActive={isDropAction === blog?.id}
                        dropActionOptions={dropActionOptions}
                        blogId={blog?.id}
                      />
                    </div>
                  </td>
                </tr>
              ))}
              {blogDraft?.length !== totalDrafts && (
          <div className="loadMoreWrapper">
            <Button
              isWaiting={
                blogDraft?.length > 0 &&
                isBlogSliceFetching
              }
              onClick={loadMore}
              className={"BlueFillButton"}
              name={"Load More"}
            />
          </div>
        )}
              {blogDraft?.length === 0 && !isBlogSliceFetching && (
                <tr>
                  <td colSpan={"11"}>
                    <span className="noData">
                      <img
                        src={
                          "https://cdn.mastersunion.org/assets/imgV2/noDataDineroNew2.png"
                        }
                        alt=""
                      />
                    </span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Draft;
